import SingleMyEMSParcelContiainer from "../containers/SingleMyEMSParcelContainer";

const SingleMyEMSParcelsPage = () => {
    return <SingleMyEMSParcelContiainer />;
};

export default SingleMyEMSParcelsPage;
